<template>
  <div class="question-mobile">
    <div v-if="question && question.type && question.type === typeGroup" class="question-group" :class="{'evt-none': question && question.isWorked}">
      <PreviewQuestion 
        :dataSource="question"
        :questions="[question]"
        :location="0"
        :preview="true"
        :questionsData="question"
        @answerMissing="handleAnswerMissing"
      />
      <div class="questions-child" v-if="question.listQuestionChild">
        <div v-for="(child, pos) of question.listQuestionChild" :key="pos" class="questions-child__item">
          <PreviewQuestion 
            v-if="child"
            :dataSource="child"
            :location="pos"
            :parentIndex="0"
            :isQuestionChild="true"
            :preview="true"
            :questionsData="question"
          />
        </div>
      </div>
      <p v-if="txtMissingQuestionGroup" class="question-missing-answer color-err">{{ txtMissingQuestionGroup }}</p>
    </div>
    <div v-else-if="question && Object.keys(question).length" class="question-single" :class="{'evt-none': question && question.isWorked}">
      <PreviewQuestion 
        :dataSource="question"
        :location="0"
        :preview="true"
        @answerMissing="handleAnswerMissing"
      />
    </div>
  </div>
</template>

<script>

// import { mapActions } from 'vuex'
// import PreviewQuestion from '@/modules/exercise-mobile/_components/question/preview-question/PreviewQuestion.vue'
import PreviewQuestion from "@/modules/question/preview-question/PreviewQuestion.vue";
import { TYPE_GROUP } from '@/modules/exercise-mobile/_components/question/preview-question/_store/constants'
import mixinExercise from '@/modules/exercise-mobile/_store/mixinExercise'
export default {
  name: 'ExerciseQuestionDetail',
  components: {
    PreviewQuestion,
  },
  mixins: [ mixinExercise ],
  props: {
    question: Object,
    txtMissingQuestionGroup: String,
    answerMissing: Function
  },
  data () {
    return {
      typeGroup: TYPE_GROUP,
    }
  },
  created () {
  },
  methods: {
    handleAnswerMissing (valErr) {
      // if(this.question.type === TYPE_GROUP) {
      this.$emit('answerMissing', valErr);
      // }
    },
  }
}
</script>

<style lang="scss" scoped>
  .btn-check-answer {
    margin-top: 10px;
    line-height: 1.2;
    letter-spacing: 0.03em;
  }
  .question-mobile {
    padding-bottom: 80px;
  }
</style>
